import { z } from "zod";

export const promocodeBatchSchema = () => {
  return z.object({
    name: z.string().min(1),
    agreement: z.number().min(1),
    quantity: z.any().optional(),
    active: z.boolean(),
  });
};

export type PromocodeBatchFormValues = z.infer<ReturnType<typeof promocodeBatchSchema>>;
